import { render, staticRenderFns } from "./rustContractDetail.vue?vue&type=template&id=02ddc4ea&scoped=true&"
import script from "./rustContractDetail.vue?vue&type=script&lang=js&"
export * from "./rustContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./rustContractDetail.vue?vue&type=style&index=0&id=02ddc4ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ddc4ea",
  null
  
)

export default component.exports